import cx from 'classnames';

import { Box, BoxProps } from '../../Elements/Box';

import * as styles from './Text.css';

export interface TextProps extends BoxProps {
  variant?: 'base' | 'link';
}

export const Text = ({
  component = 'p',
  fontSize = 'base',
  variant = 'base',
  ...props
}: TextProps) => {
  return (
    <Box
      className={cx({ [styles.link]: variant === 'link' })}
      component={component}
      fontSize={fontSize}
      lineHeight={fontSize}
      {...props}
    />
  );
};
